export enum SidebarView {
  ROOT,
  ACCOUNT,
  TENANT,
  ADD_ROOM,
  ADD_DIRECT,
  CONNECT,
}
